<template>
  <div v-if="item">
    <p v-html="getContentParameterization" v-tooltip="getTooltip"></p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

const HEADER = 'HEADER';
const BODY = 'BODY';

export default {
  props: {
    item: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      hasErrorTooltip: false,
    };
  },
  methods: {
    replaceContent(content, type) {
      const { parameterizations } = this.item;

      parameterizations
        .filter(param => param.type === type)
        .forEach(({ key, value }) => {
          if (!value) this.hasErrorTooltip = true;

          content = content.replace(key, value || `${key}*`);
        });

      return content;
    },
  },
  computed: {
    ...mapGetters({
      inboxes: 'inboxes/getInboxes',
    }),
    getTemplate() {
      const { inbox, template } = this.item;

      return this.inboxes
        .find(({ id }) => inbox.id === id)
        .message_templates.find(({ id }) => template.code === id);
    },
    getTemplateHeader() {
      return this.getTemplate.components.find(({ type }) => type === HEADER);
    },
    getTooltip() {
      if (!this.hasErrorTooltip) return;

      return this.$t('TEMPLATE_PARAMETERIZATION.LIST.PARAMETERIZATION.WARNING');
    },
    templateStringHeader() {
      return this.getTemplateHeader?.text ?? '';
    },
    templateStringBody() {
      return this.getTemplate.components.find(({ type }) => type === BODY).text;
    },
    getContentParameterization() {
      let text = '';

      if (this.templateStringHeader) {
        text += this.replaceContent(this.templateStringHeader, HEADER);
        text += '<br>';
      }

      if (this.templateStringBody) {
        text += this.replaceContent(this.templateStringBody, BODY);
      }

      return text;
    },
  },
};
</script>